export { default as deleteHPAModal } from './DeleteHPAModal';
